import React from "react";
import styles from "./workflowFlowchart.module.scss";

const WorkflowFlowchart = () => {
  const steps = [
    {
      id: 1,
      text: "Create press release",
      gradient: "linear-gradient(180deg, #455391 0%, #8C9DEC 100%)",
    },
    {
      id: 2,
      text: "Translates to arabic",
      gradient: "linear-gradient(180deg, #35b7e1 0%, #a1e4e9 100%)",
    },
    {
      id: 3,
      text: "Creates media Q&A brief",
      gradient: "linear-gradient(180deg, #2bb36f 0%, #77d9a7 100%)",
    },
    {
      id: 4,
      text: "Writes social media posts",
      gradient: "linear-gradient(180deg, #ff3d52 0%, #ff6e80 100%)",
    },
    {
      id: 5,
      text: "Writes corporate communications email",
      gradient: "linear-gradient(180deg, #c470b6 0%, #fea1f0 100%)",
    },
  ];

  return (
    <div className={styles.workflowFlowchart}>
      {steps.map((step, index) => (
        <React.Fragment key={step.id}>
          <div
            className={styles.flowStep}
            style={{ background: step.gradient }}
          >
            <div className={styles.stepText}>{step.text}</div>
          </div>
          {index < steps.length - 1 && <div className={styles.triangle}></div>}
        </React.Fragment>
      ))}
    </div>
  );
};

export default WorkflowFlowchart;
